import React from "react";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import "./Footer.css";
import matchlessMark from "../../assets/matchless.png";
import ajsMark from "../../assets/ajs.png";
import matchlessReputationLogo from "../../assets/matchless-reputation-logo.png";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="site-footer__main">
        <div className="site-footer__brand-marks" aria-hidden="true">
          <img src={matchlessMark} alt="" />
          <img src={ajsMark} alt="" />
        </div>

        <div className="site-footer__message">
          <img
            className="site-footer__reputation-logo"
            src={matchlessReputationLogo}
            alt="Matchless in name and reputation"
          />
          <p className="site-footer__copy">The club for all Matchless &amp; AJS owners</p>
          <p className="site-footer__founded">Founded 1952</p>
        </div>

        <div className="site-footer__socials" aria-label="Follow us">
          <a href="https://www.facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook">
            <FaFacebookF />
          </a>
          <a href="https://www.instagram.com" target="_blank" rel="noreferrer" aria-label="Instagram">
            <FaInstagram />
          </a>
        </div>
      </div>

      <p className="site-footer__details">AJS &amp; Matchless Owners Club Ltd. | Devon &amp; Cornwall Section</p>
    </footer>
  );
}

export default Footer;
